(() => {
  'use strict';
  const key = 'souqiza.recent.v1';
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  let generation = 0;
  function whatsapp() {
    document.querySelectorAll('[data-whatsapp-number]').forEach(link => {
      const number = link.dataset.whatsappNumber.trim();
      if (!/^[1-9][0-9]{7,14}$/.test(number)) return;
      link.href = `https://wa.me/${number}`;
      link.hidden = false;
    });
  }
  async function recent() {
    const version = ++generation;
    const sections = [...document.querySelectorAll('[data-recent-section]')];
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.preferencesProcessingAllowed !== 'function') return;
    const allowed = privacy.preferencesProcessingAllowed() === true;
    if (!allowed) {
      sections.forEach(section => { section.hidden = true; section.querySelector('[data-recent-grid]').replaceChildren(); });
      try { localStorage.removeItem(key); } catch (_) { /* Storage may be unavailable. */ }
      return;
    }
    let records;
    const now = Date.now();
    const current = document.querySelector('[data-recent-product]')?.dataset.recentProduct;
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      records = (Array.isArray(stored) ? stored : []).filter(item => item && validHandle(item.handle) && Number.isFinite(item.time) && item.time <= now && now - item.time < 30 * 86400000);
      records = records.filter((item, index, all) => all.findIndex(other => other.handle === item.handle) === index).slice(0, 8);
      const updated = validHandle(current) ? [{handle:current,time:now},...records.filter(item => item.handle !== current)].slice(0,8) : records;
      localStorage.setItem(key, JSON.stringify(updated));
    } catch (_) { return; }
    if (!sections.length) return;
    const root = window.SouqizaRoutes?.root || '/';
    const products = await Promise.all(records.filter(item => item.handle !== current).slice(0,6).map(async item => {
      try {
        const response = await fetch(`${root.replace(/\/$/,'')}/products/${encodeURIComponent(item.handle)}.js`,{credentials:'same-origin',cache:'no-store'});
        if (!response.ok) return null;
        const product = await response.json();
        return validHandle(product.handle) && Number.isFinite(product.price) && typeof product.title === 'string' ? product : null;
      } catch (_) { return null; }
    }));
    if (version !== generation || window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() !== true) return;
    sections.forEach(section => {
      const grid = section.querySelector('[data-recent-grid]'); grid.replaceChildren();
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:section.dataset.currency});
      products.filter(Boolean).forEach(product => {
        const link = document.createElement('a'); link.href = `${root.replace(/\/$/,'')}/products/${product.handle}`;
        if (product.featured_image) {
          try { const url = new URL(product.featured_image, location.origin); if (url.protocol === 'https:') {const image=document.createElement('img');image.src=url.href;image.alt=product.title;image.loading='lazy';image.width=300;image.height=300;link.append(image);} } catch (_) { /* Missing image does not hide the product. */ }
        }
        const title=document.createElement('h3');title.textContent=product.title;
        const price=document.createElement('p');price.textContent=`${product.price_varies?'From ':''}${money.format(product.price/100)}${product.available?'':' · Sold out'}`;
        link.append(title,price);grid.append(link);
      });
      section.hidden = !grid.children.length;
    });
  }
  function bundles() {
    document.querySelectorAll('[data-bundle-offer]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const select = section.querySelector('[data-bundle-variant]');
      const radios = [...section.querySelectorAll('[name="quantity"]')];
      function update() {
        const option = select.selectedOptions[0];
        if (!option) return;
        const min = Number(option.dataset.min) || 1, step = Number(option.dataset.step) || 1;
        const max = option.dataset.max ? Number(option.dataset.max) : Infinity;
        radios.forEach(radio => { const n=Number(radio.value);radio.disabled=option.dataset.available!=='true'||n<min||n>max||(n-min)%step!==0;if(radio.disabled)radio.checked=false; });
        if (!radios.some(radio=>radio.checked)) { const valid=radios.find(radio=>!radio.disabled);if(valid)valid.checked=true; }
        const valid=radios.some(radio=>radio.checked&&!radio.disabled);
        section.querySelector('[data-bundle-add]').disabled=!valid;
        section.querySelector('[data-bundle-message]').textContent=valid?'Your selected quantity will be added at Shopify prices. Eligible discounts appear in your cart.':'These quantities are unavailable for this option. Choose another option or visit the product page.';
      }
      select.addEventListener('change',update);
      section.querySelector('form').addEventListener('submit',event=>{update();if(section.querySelector('[data-bundle-add]').disabled)event.preventDefault();});
      update();
    });
  }
  function init(){whatsapp();recent();bundles();}
  document.addEventListener('visitorConsentCollected', recent);
  document.addEventListener('shopify:section:load', init);
  init();
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) recent(); });
  }
})();
